import { match } from 'ts-pattern'
import { InboxPreview } from 'Automations/components'
import { automationsPaths } from 'Automations/router'
import { useSelectedManualTask } from 'Automations/watchtower/inbox/manualTasks/hooks/useSelectedManualTask'
import { isNotification } from 'Automations/watchtower/inbox/notifications'
import { ManualTaskPreview } from 'Automations/watchtower/inbox/manualTasks/manualTasksInbox/components/manualTaskPreview/ManualTaskPreview'
import { ListView } from '../inbox.types'
import { NotificationPreview } from '../notifications/components/NotificationPreview'

export const TaskPreview = ({ view }: { view: ListView }) => {
  const { selectedManualTask, isPending } = useSelectedManualTask()
  const dismissNavigateTo = match(view)
    .with('all', () => automationsPaths.executionInbox())
    .with('needsAction', () => automationsPaths.manualTasksInbox())
    .exhaustive()

  if (isPending) {
    return <InboxPreview.LoadingState />
  }

  if (!selectedManualTask) {
    return <InboxPreview.EmptyState />
  }

  return isNotification(selectedManualTask.type) ? (
    <NotificationPreview
      task={selectedManualTask}
      dismissNavigateTo={dismissNavigateTo}
    />
  ) : (
    <ManualTaskPreview />
  )
}
